import { useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { LS } from '../utils/lang';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_VERSE = {
  book: 'John',
  chapter: 3,
  verse: 16,
  text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
  translation: 'KJV',
  reference: 'John 3:16',
};

/**
 * Selected-verse + AI-insight state shared across dashboard panes.
 * Extracted from Dashboard.jsx so the parent can stay <100 lines.
 */
export const useDashboardSelection = ({ language } = { language: 'en' }) => {
  const [selectedVerse, setSelectedVerse] = useState(DEFAULT_VERSE);
  const [aiInsights, setAIInsights] = useState(null);
  const [showAIInsights, setShowAIInsights] = useState(false);
  const [isLoadingAI, setIsLoadingAI] = useState(false);

  const handleAIAnalyze = useCallback(async (verse) => {
    setIsLoadingAI(true);
    try {
      const r = await axios.post(
        `${BACKEND_URL}/api/ai/analyze`,
        { verse, language: LS('en', 'es') },
        { withCredentials: true },
      );
      setAIInsights(r.data);
      setShowAIInsights(true);
      toast.success(language === 'es' ? 'Análisis IA completado' : 'AI analysis complete');
    } catch {
      toast.error(language === 'es' ? 'Análisis IA falló' : 'AI analysis failed');
    } finally {
      setIsLoadingAI(false);
    }
  }, [language]);

  return {
    selectedVerse,
    setSelectedVerse,
    aiInsights,
    showAIInsights,
    isLoadingAI,
    handleAIAnalyze,
  };
};
